import React from 'react';

/* ─── Text (unified, supports rich content + legacy) ── */
function Text({ content, text, bold = false, opacity }) {
    const style = opacity != null && opacity !== 1 ? { opacity } : undefined;

    if (content && Array.isArray(content)) {
        return (
            <span style={{ ...style, whiteSpace: 'pre-line' }}>
                {content.map((span, i) => renderSpan(span, i))}
            </span>
        );
    }

    // Legacy plain-text format
    const inner = <span style={{ ...style, whiteSpace: 'pre-line' }}>{text}</span>;
    return bold ? <b style={style}>{inner}</b> : inner;
}

function renderSpan(span, i) {
    let node = span.t;
    if (span.href) node = <a href={span.href} target="_blank" rel="noreferrer">{node}</a>;
    if (span.u)    node = <u>{node}</u>;
    if (span.i)    node = <i>{node}</i>;
    if (span.b)    node = <b>{node}</b>;
    return <React.Fragment key={i}>{node}</React.Fragment>;
}

/* ─── TextBlock (backward compat) ───────────────────── */
function TextBlock({ text }) {
    return <Text content={[{ t: text }]} />;
}

/* ─── Other text atoms ────────────────────────────── */
function Link({ text, destination, newTab = false, bold = false }) {
    const anchor = <a href={destination} target={newTab ? '_blank' : '_self'}>{text}</a>;
    return bold ? <b>{anchor}</b> : anchor;
}

function NewLine() { return <br />; }

function Heading({ type = 1, text, topSpace = 0.7 }) {
    const style = { marginTop: topSpace + 'em' };
    switch (type) {
        case 2: return <h2 id={text} style={style}>{text}</h2>;
        case 3: return <h3 id={text} style={style}>{text}</h3>;
        case 4: return <h4 id={text} style={style}>{text}</h4>;
        default: return <h1 id={text} style={style}>{text}</h1>;
    }
}

function NavLink({ id, text, destination }) {
    return (
        <a href={destination} target="_self" className="ref">
            <div className="navItem inactive" id={id}>{text}</div>
        </a>
    );
}

export { Link, Text, TextBlock, NewLine, Heading, NavLink };
